import { useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { SnackbarAlert } from "../../components/SnackbarAlert";
import Signature from "../Tms/CommonComponents/Signature/Signature";
import { getUserSignatures } from "../Tms/CommonComponents/Signature/hooks/getSignature";
import { saveUserSignature } from "../Tms/CommonComponents/Signature/hooks/getSignature";
import { SignatureGallery } from "../Tms/CommonComponents/Signature/tabs/SignatureGallery";

const Signatures = ({ data }) => {
    const [loading, setLoading] = useState(false);
    const [signatures, setSignatures] = useState(null);
    const [notif, setNotif] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const userId = data?.id;

    const handleSubmit = async (payload) => {
        try {
            setLoading(true);
            const response = await saveUserSignature({ userId, payload });

            const updatedSignatures =
                response.data?.signatures ?? payload.signatures;
            setSignatures(updatedSignatures);

            setNotif({
                open: true,
                message: "Signature saved successfully.",
                severity: "success",
            });
        } catch (err) {
            setNotif({
                open: true,
                message:
                    err?.response?.data?.message ?? "Failed to save signature.",
                severity: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!userId) return;
        getUserSignatures({ id: userId })
            .then((res) => setSignatures(res.data?.signatures))
            .catch((err) => console.error("Failed to load signatures", err));
    }, [userId]);

    return (
        <>
            <Container>
                <Card>
                    <Card.Header>
                        <Card.Title className="mb-0">Signatures</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <SignatureGallery signatures={signatures} />
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Header>
                        <Card.Title className="mb-0">Add Signature</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Signature
                            onSubmit={handleSubmit}
                            loadingSignatures={loading}
                            fetchSignatures={() =>
                                getUserSignatures({ id: userId })
                            }
                            additionalPayloadData={{ userId }}
                            hideSelectTab={true}
                        />
                    </Card.Body>
                </Card>
            </Container>
            <SnackbarAlert notif={notif} setNotif={setNotif} />
        </>
    );
};

export default Signatures;
